import { confirmDialog } from '@/components/ConfirmDialog';

export interface LifecycleConfirm {
  /** The kind of record, in lower case: "customer", "brand". Goes on the button. */
  what: string;
  /** The record's own name, so the question says exactly which one. */
  name: string;
  /** What goes with it or stops working: "Its buyers can't sign in to the portal." */
  consequence?: string;
}

function sentence(text: string | undefined): string {
  const t = text?.trim();
  if (!t) return '';
  return /[.!?]$/.test(t) ? `${t} ` : `${t}. `;
}

/**
 * Ask before archiving (decision 50 c): a red confirm that names the record and says what
 * archiving does. Resolves true when the person confirms. Archived records can be restored, so
 * the question says so.
 */
export function confirmArchive({ what, name, consequence }: LifecycleConfirm): Promise<boolean> {
  return confirmDialog({
    title: `Archive ${name}?`,
    description: `${sentence(consequence)}You can restore it later.`,
    confirmLabel: `Archive ${what}`,
    destructive: true,
  });
}

/**
 * Ask before a permanent delete: a red confirm that names the record, says what goes with it and
 * that it can't be undone. Prefer archive where the record has one (record-lifecycle.mdc).
 */
export function confirmDelete({ what, name, consequence }: LifecycleConfirm): Promise<boolean> {
  return confirmDialog({
    title: `Delete ${name}?`,
    description: `${sentence(consequence)}This can't be undone.`,
    confirmLabel: `Delete ${what}`,
    destructive: true,
  });
}
